import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
class Header extends Component {
	constructor(props) {
		super(props);
		this.logout = this.logout.bind(this);
	}
	logout() {
		localStorage.setItem("userLogin", "");
		localStorage.clear();
		<Redirect to={"/login"} />;
		window.parent.location = window.parent.location.href;
	}
	render() {
		return (
			<ul class="nav nav-pills">
				<li class={this.props.brecum_page == "customerlist" ? "active" : ""}>
					<Link to={`/test/customers/`} name={"max"}>
						Customers
					</Link>
				</li>
				<li class={this.props.brecum_page == "leadlist" ? "active" : ""}>
					<Link to={`/test/leads/`} name={"max"}>
						Leads
					</Link>
				</li>
				<li class={this.props.brecum_page == "cancellist" ? "active" : ""}>
					{" "}
					<Link to={`/test/cancelledStores/`} name={"max"}>
						Cancelled
					</Link>
				</li>
				<li class={this.props.brecum_page == "deletelist" ? "active" : ""}>
					<Link to={`/test/deletedStores/`} name={"max"}>
						Deleted
					</Link>
				</li>
				<li class={this.props.brecum_page == "demolist" ? "active" : ""}>
					<Link to={`/test/demoStores/`} name={"max"}>
						Demo
					</Link>
				</li>
				<li class={this.props.brecum_page == "alllist" ? "active" : ""}>
					<Link to={`/test/allStores/`} name={"max"}>
						All
					</Link>{" "}
				</li>
				<li class={this.props.brecum_page == "enterpriselist" ? "active" : ""}>
					<Link to={`/test/enterpriseCustomers/`} name={"max"}>
						Enterprise
					</Link>
				</li>
			</ul>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/customer/CustomerTabMenu.js